import { SectionHead, Reveal } from "./Reveal";

const STEPS = [
  { title: "Add your photo", text: "A clear phone photo of your car, bike, motorcycle, yourself or anything else. Parked, posed or candid." },
  { title: "Pick the new scene", text: "Choose one of our worlds, upload your own background, or make one with the Image Generator. For Person Swap, add a photo of the new person." },
  { title: "Swap it", text: "Your new image is ready in under a minute, right in the Studio. Download it, post it, and find it again any time in My Orders." },
];

export const HowItWorks = () => (
  <section id="how" data-testid="how-it-works-section" className="relative py-20 lg:py-28 border-t border-white/5">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
      <SectionHead center eyebrow="Three steps" title="How it works" />
      <div className="grid md:grid-cols-3 gap-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1}>
            <div data-testid={`step-card-${i + 1}`} className="group relative h-full panel p-7 lg:p-9 overflow-hidden transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-[#d5d9df]/40">
              <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#3b4049]/0 blur-3xl transition-[background-color] duration-700 group-hover:bg-[#3b4049]/30" />
              <span className="relative h-10 w-10 rounded-lg bg-[#3b4049] grid place-items-center font-display font-bold shadow-[0_0_30px_rgba(190,197,208,0.6)]">{i + 1}</span>
              <h3 className="relative font-display text-lg lg:text-xl font-semibold mt-8 mb-3">{s.title}</h3>
              <p className="relative text-slate-300 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
